import { ItemsGrid } from '@rdrive/plugin-items-grid';
import { TotalAndAssignedCards } from '@rdrive/plugin-total-cards';
import { StackedHorizontalBarChart } from '@rdrive/plugin-chart-stacked-bar';
import setup from './setup.js';

export default {
  name: 'drawings-page',
  components: { ItemsGrid, TotalAndAssignedCards, StackedHorizontalBarChart },
  setup,
};
